// Analyse: von der gezeigten Stellung in den Spielmodus – gegen einen Bot weiterspielen oder, bei einer
// Partie der Bibliothek auf der Partielinie, die Züge eines der beiden Spieler raten („Spiel wie …“).
import { h, type VNode } from 'snabbdom';
import { t } from '../i18n';
import { continueHref, guessHref, shortName } from '../playstart';
import type { AnalyseCtrl } from './analyse';

export function gameLinks(c: AnalyseCtrl): VNode[] {
  const links = [h('a.link', { attrs: { href: continueHref(c.node.fen) } }, t('Ab hier weiterspielen'))];
  const g = c.data?.game;
  if (g && c.gameId !== null && c.node.game) {
    const ply = c.node.ply - c.root.ply;
    for (const [side, name] of [['white', g.white], ['black', g.black]] as const)
      links.push(h('a.link', { attrs: { href: guessHref(c.gameId, side, ply) } }, t('Spiel wie {n}', { n: shortName(name) })));
  }
  return links;
}
